var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
__export(exports, {
  useChain: () => useChain,
  useChains: () => useChains
});
var import_chaindata_js = __toModule(require("@talismn/chaindata-js"));
var import_react = __toModule(require("react"));
function useChains() {
  const [chainData, setChainData] = (0, import_react.useState)(null);
  (0, import_react.useEffect)(() => {
    ;
    (() => __async(this, null, function* () {
      return setChainData(yield import_chaindata_js.default.chains());
    }))();
  }, []);
  return chainData;
}
function useChain(id) {
  const [chain, setChain] = (0, import_react.useState)({});
  (0, import_react.useEffect)(() => {
    if (id === void 0)
      return setChain({});
    (() => __async(this, null, function* () {
      return setChain(yield import_chaindata_js.default.chain(id));
    }))();
  }, [id]);
  return chain;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useChain,
  useChains
});
